module.exports = __webpack_public_path__ + "static/img/qr_code.de5b859.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr_code.jpg
// module id = IWkE
// module chunks = 16